export interface GameLogs {
  date: string;
  gamesPlayed: number;
  wins: number;
  losses: number;
}

export const getColorForGamesPlayed = (count: number): string => {
  if (count === 0) return "#3273FA0D";
  if (count === 1) return "#3273FA4D";
  if (count === 2) return "#3273FA80";
  if (count >= 3 && count <= 4) return "#3273FAB2";
  else return "#3273FA";
};

export const getWeekOfYear = (date: Date): number => {
  const year = date.getFullYear();
  const start = new Date(year, 0, 1);
  const current = new Date(year, date.getMonth(), date.getDate());

  // Reset time to avoid DST issues
  start.setHours(0, 0, 0, 0);
  current.setHours(0, 0, 0, 0);

  const dayOfYear = Math.round((current.getTime() - start.getTime()) / (24 * 60 * 60 * 1000));
  const startDayOfWeek = start.getDay();

  return Math.floor((dayOfYear + startDayOfWeek) / 7);
};

export const formatDateForTooltip = (dateString: string): string => {
  const date = new Date(dateString + "T00:00:00");
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const monthName = monthNames[date.getMonth()];
  const day = date.getDate();
  return `${monthName}. ${day}`;
};

export const getMonthLabels = (year: number): Array<{ month: string; weekOffset: number }> => {
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const labels: Array<{ month: string; weekOffset: number }> = [];

  for (let month = 0; month < 12; month++) {
    const firstOfMonth = new Date(year, month, 1);
    const weekOffset = getWeekOfYear(firstOfMonth);
    labels.push({
      month: monthNames[month],
      weekOffset,
    });
  }

  return labels;
};
